"use strict";

/**
* Диалог со справочником в табличном режиме.
*
* @class WebAccess.components.dialogs.ReferenceGridDialog
* @extends WebAccess.components.dialogs.BaseDialog
* @since 5.4.0.1012
*
* Открывает справочник в табличном режиме в iframe в диалоговом окне.
*

* @param {object} settings Настройки диалога со справочником:
*   @param {string} referenceName Код справочника
*   @param {string} [referenceCaption] Заголовок справочника
*   @param {string} [context] Контекст представления справочника (объединяется с "modal.")
*   @param {REFERENCE_MODAL_MODE} [mode] Режим открытия справочника (MULTI – множественный выбор, SINGLE – единичный выбор, VIEW – просмотр)
*   @param {string} [filterQuery] Фильтр справочника - значение, введенное с клавиатуры в поле ввода
*   @param {string} [filterExpression] Выражение фильтрации
*   @param {array} [visibleColumns] Порядок и состав видимых колонок справочника, если их еще нет в сохраненном контексте
*   @param {string} [modalDialogTitle] Заголовок модального окна
* @property {string} className Имя текущего класса

* @example
* var dialog = new WebAccess.components.dialogs.ReferenceGridDialog({referenceName:"РАБ"});
* dialog.bind("close", function(data) {});
* dialog.show();
*/
(function (global) {
  var BROWSER_TOOLBAR_HEIGHT = 100;

  var MIN_DIALOG_MARGIN = 40;
  var MAX_DIALOG_MARGIN_PERCENT = 30; // отступы 30% от размера браузера, но не менее MIN_DIALOG_MARGIN.

  var ReferenceGridDialog = global.BaseDialog.extend({
    className: 'ReferenceGridDialog',
    height: MIN_SUPPORTS_WINDOW_HEIGHT - BROWSER_TOOLBAR_HEIGHT - MIN_DIALOG_MARGIN,
    width: MIN_SUPPORTS_WINDOW_WIDTH - MIN_DIALOG_MARGIN,
    isShowOkButton: false,
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    init: function (settings) {
      var me = this;
      me._super(settings);
      me.settings = settings;

      if (me.settings.modalDialogTitle) {
        me.title = me.settings.modalDialogTitle;
      } else {
        me._addReferenceCaptionToTitle();
      }

      var referenceUrl = me._makeReferenceRecordUrl(me.settings.referenceName, me.settings.context, me.settings.mode,
        me.settings.filterExpression, me.settings.filterQuery, me.settings.visibleColumns, me.settings.hideToolbar,
        me.settings.queryContext, me.settings.leaderSelectedId);
      me.html = '<iframe src="' + referenceUrl + '" class="reference-grid-iframe" scrolling="no"></iframe>';

      me._changeDialogBodyMinWidth();

      me._changeDialogDimensions();

      me._bindDialogEvents();

      if (me.settings.mode == REFERENCE_MODAL_MODE.SINGLE) {
        me._addSelectRecordColumn();
      }

      return me;
    },

    // Добавляет заголовок справочника в заголовок модального окна.
    _addReferenceCaptionToTitle: function () {
      var me = this;
      var filterTitle = me.filterQuery ? (L('REFERENCE_GRID_DIALOG_TITLE_FILTER_QUERY') + '"' + me.filterQuery.escapeHtml() + '"') : '';
      if (me.referenceCaption) {
        me.setTitle(format(L('REFERENCE_GRID_DIALOG_TITLE_WITH_REFERENCE_CAPTION') + filterTitle, me.referenceCaption.escapeHtml()));
      } else {
        // Временно установим общий заголовок без названия справочника.
        me.setTitle(L('REFERENCE_GRID_DIALOG_TITLE') + filterTitle);
        WebAccess.services.reference.getReferenceCaption(me.settings.referenceName).done(function (caption) {
          me.setTitle(format(L('REFERENCE_GRID_DIALOG_TITLE_WITH_REFERENCE_CAPTION') + filterTitle, caption.escapeHtml()));
        });
      }
    },

    // Формирует URL для вызова справочника в iframe в модальном окне
    _makeReferenceRecordUrl: function (compcode, context, modalmode, filter, likefilter, columns, hideToolbar, queryContext, leaderSelectedId) {
      var cols = columns;
      // Обязательные колонки.
      if (cols) {
        cols.unshift('_Checkbox');
      }

      var url = WA.FC.references(compcode).toURL();
      url.setParam('context', context ? ('modal.' + context) : 'modal');
      if (modalmode) url.setParam('modalmode', modalmode);
      if (filter) url.setParam('filter', filter);
      if (likefilter) url.setParam('likefilter', likefilter);
      if (cols) url.setParam('columns', cols.join(';'));
      if (hideToolbar) url.setParam('hidetoolbar', '1');
      if (queryContext) url.setParam('querycontext', queryContext);
      if (leaderSelectedId) url.setParam('leaderSelectedId', encodeURIComponent(leaderSelectedId));

      return url.asString();
    },

    _changeDialogBodyMinWidth: function () {
      var me = this;
      me.bind(me['class'].EVENT.AFTER_OPEN, function () {
        var jIframe = me._jDialog.find('iframe').eq(0);
        jIframe.on('load', function () {
          var IframeWindow = jIframe.get(0).contentDocument;
          $(IframeWindow.body).addClass('reference_dialog_body');
        });
      });
    },

    // Изменяет размеры диалогового окна в зависимости от размеров экрана
    _changeDialogDimensions: function () {
      var me = this;
      var ww = $(window).width();
      var wh = $(window).height();

      // ширина диалога с отступами MAX_DIALOG_MARGIN_PERCENT % от ширины браузера, либо с отступами MIN_DIALOG_MARGIN при малой ширине браузера.
      var dialogWidth = ww * (1 - MAX_DIALOG_MARGIN_PERCENT / 100);
      if (dialogWidth > MIN_SUPPORTS_WINDOW_WIDTH)
        me.setWidth(dialogWidth);
      else
        me.setWidth(ww - MIN_DIALOG_MARGIN);

      var dialogHeight = wh - MIN_DIALOG_MARGIN;
      if (dialogHeight > MIN_SUPPORTS_WINDOW_HEIGHT)
        me.setHeight(dialogHeight);
      else
        me.setHeight(wh - MIN_DIALOG_MARGIN);
    },

    // Подписывается и отписывается на событие получения сообщения и закрытия диалога
    _bindDialogEvents: function () {
      var me = this;
      $(window)
        .on("message.ReferenceGridDialog", function (e) {
          me._sendSelectedRecords(e);
        })
        .on("resizeEnd.ReferenceGridDialog", function () {
          me._changeDialogDimensions();
          me._placeInCenter();
        });

      // Вызываем событие resizeEnd для пересчитывания размеров ленты справочника и иконок в ней
      me.bind(me['class'].EVENT.AFTER_OPEN, function () {
        var jIframe = me._jDialog.find('iframe').eq(0);
        jIframe.on('load', function () {
          jIframe.trigger('resizeEnd');
        });
      });

      me.bind(me['class'].EVENT.AFTER_CLOSE, function () {
        $(window)
          .off("message.ReferenceGridDialog")
          .off("resizeEnd.ReferenceGridDialog");
      });

      if (me.settings.mode !== REFERENCE_MODAL_MODE.VIEW) {
        me.bind(me['class'].EVENT.AFTER_OPEN, function () {

          var jIframe = me._jDialog.find('iframe').eq(0);
          // Когда iframe загрузился.
          jIframe.on('load', function () {

            // Добавляем кнпоку "Выбрать".
            me._initSelectionButton(me.settings.referenceName);
            if (me.settings.mode == REFERENCE_MODAL_MODE.SINGLE) {
              me._bindDisableSelectButtonInSigleMode(me.settings.referenceName);
            } else {
              me._bindDisableSelectButtonInMultiMode(me.settings.referenceName);
            }
          });
        });
      }
    },

    _addSelectRecordColumn: function () {
      var me = this;
      //var jIframe = me._jDialog.find('iframe').eq(0);
      if (me.settings.mode !== REFERENCE_MODAL_MODE.VIEW) {
        me.bind(me['class'].EVENT.AFTER_OPEN, function () {

          var jIframe = me._jDialog.find('iframe').eq(0);

          // Когда iframe загрузился.
          jIframe.on('load', function () {
            var IframeWindow = jIframe.get(0).contentWindow;
            // Когда grid проинициализировался.
            $.when(IframeWindow.Core.grid.referenceInit).then(function () {
              // Регистрируем глобальную функцию для клика по ссылке в ячейке грида.
              IframeWindow.ReferenceGridDialogCellClick = function (ev, el) {
                var recId = $(el).parents('.slick-row').eq(0).data('recid');
                var selectedRow = IframeWindow.Core.grid.reference.dataView.getItemById(recId);
                var leaderValues = me._getLeaderValues(selectedRow);
                IframeWindow.WebAccess.components.dialogs.ReferenceGridDialog.sendRecordById(me.settings.referenceName, recId, leaderValues);
              };

              // Функция пересортировки полей справочника
              var grid = IframeWindow.Core.grid.reference;
              var columns = grid.getColumns();
              var columnsAmount = columns.length;
              var selectRecordColumnIndex = 0;
              for (var i = 0; i < columnsAmount; i++) {
                var isSpecialColumn = (columns[i].id.charAt(0) == '_') ? true : false;
                if (isSpecialColumn) {
                  selectRecordColumnIndex = columns[i].index + 1;
                }
                else if (columns[i].index > -1) {
                  columns[i].index += 1;
                }
              }
              // Параметры добавляемой колонки "Выбрать"
              var selectRecordColumn = {
                cssClass: "centered",
                formatter: function () {
                  return '<p class="detailCell detailCell_visible-on-hover" onclick="ReferenceGridDialogCellClick(event, this)">'
                    + '<svg class="detailCell__icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#accept-16"/></svg>'
                    + L('SELECT_RECORDS') + '</p>';
                },
                headerCssClass: "notDraggable",
                id: "_SelectRecord",
                index: selectRecordColumnIndex,
                name: "&nbsp;",
                field: null,
                resizable: false,
                sortable: false,
                visible: true,
                width: (L("SELECT_RECORDS").length * 11 + 25)
              }
              columns.push(selectRecordColumn);
              grid.setColumns(columns);
            });
          });
        });
      }
    },

    // Возвращает значения ведущих реквизитов.
    _getLeaderValues: function (row) {
      var me = this;
      var leaderValues = {};
      if (me.settings.leaderSelectedId) {
        //убираем последний символ '&'
        var leadReqNames = me.settings.leaderSelectedId.slice(0, -1).split('&').map(function (selId) {
          return selId.split("|")[0];
        });
        leadReqNames.forEach(function (leadColumnName) {
          leaderValues[leadColumnName] = [
            row[leadColumnName],
            row["SBRSE_" + leadColumnName + "_Text"],
            row["SBRSE_" + leadColumnName + "_Text"],
            {}
          ];
        });
      }
      return leaderValues;
    },

    // Возвращает массив с выбранными в справочнике значениями при получении postMessage из ифрейма
    _sendSelectedRecords: function (e) {
      var me = this;
      var data = e.originalEvent.data;
      var locationOrigin = !location.origin ? (location.protocol + '//' + location.host) : location.origin;
      if (e.originalEvent.origin != locationOrigin) {
        console.log("Домен отправителя postMessage не совпадает с доменом адресата: " + e.originalEvent.origin);
        return false;
      }
      if (data.destination == 'ReferenceGridDialog') {
        me.fire('select', data.selectedItems);
        me.close();
      }

    },

    // Добавляет кнопку "выбрать" в ленту справочника при открытии его в диалоговом окне.
    _initSelectionButton: function (referenceCode) {
      var me = this;
      var IframeWindow = me._jDialog.find('iframe').get(0).contentWindow;
      $.when(IframeWindow.WA.ToolBarInit).then(function () {
        var afterGroupName = 'TOOLBAR_DOC_FOLDER_TASK_GROUP';
        // Если группа есть, вставляем после ней, иначе вставляем в самое начало.
        if (!IframeWindow.WA.CR.toolBar.groups[afterGroupName]) {
          afterGroupName = '';
        }
        IframeWindow.WA.CR.toolBar.groups.create("TOOLBAR_SELECT_RECORDS", afterGroupName);
        IframeWindow.WA.CR.toolBar.groups['TOOLBAR_SELECT_RECORDS'].createButton({
          name: "SelectRecords",
          text: L("SELECT_RECORDS"),
          icon: "accept-20",
          toolTip: L("CLICK_TO_SELECT_RECORDS"),
          jsaction: function () {
            var selectedRecords = IframeWindow.WA.CR.objectList.getSelectedItems();
            if (me.settings.mode === REFERENCE_MODAL_MODE.SINGLE && selectedRecords.length === 1) {
              var recId = selectedRecords[0].id;
              var selectedRow = IframeWindow.Core.grid.reference.dataView.getItemById(recId);
              var leaderValues = me._getLeaderValues(selectedRow);
              IframeWindow.WebAccess.components.dialogs.ReferenceGridDialog.sendRecordById(referenceCode, recId, leaderValues);
            } else {
              IframeWindow.WebAccess.components.dialogs.ReferenceGridDialog.sendMultiSelectedRecords(referenceCode, selectedRecords);
            }
          }
        });
      });
    },

    // Блокирует кнопку выбора, если не выбрана только 1 запись.
    _bindDisableSelectButtonInSigleMode: function (referenceCode) {
      var me = this;
      $.when(WA.ObjectListInit).then(function () {
        var IframeWindow = me._jDialog.find('iframe').get(0).contentWindow;
        IframeWindow.WA.CR.objectList.bind('onChange', function (records) {
          var btn = IframeWindow.WA.CR.toolBar.groups['TOOLBAR_SELECT_RECORDS'].getButtons()['SelectRecords'];
          if (records.length === 1) {
            btn.enable();
          } else {
            btn.disable();
          }
        });
      });
    },

    // Блокирует кнопку выбора, если не выбрано ни одной записи.
    _bindDisableSelectButtonInMultiMode: function (referenceCode) {
      var me = this;
      $.when(WA.ObjectListInit).then(function () {
        var IframeWindow = me._jDialog.find('iframe').get(0).contentWindow;
        IframeWindow.WA.CR.objectList.bind('onChange', function (records) {
          var btn = IframeWindow.WA.CR.toolBar.groups['TOOLBAR_SELECT_RECORDS'].getButtons()['SelectRecords'];
          if (records.length < 1) {
            btn.disable();
          } else {
            btn.enable();
          }
        });
      });
    }

    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  }, {
    // static

    /**
    * Создает и отображает модальное окно со справочником.
	*
    * @since 5.4.0.1012
    * @function WebAccess.components.dialogs.ReferenceGridDialog.createAndShow
    *
    * @param {object} settings Настройки диалога со справочником
    * @return {object} Объект с функциями selectionDone и selectionCancel, которые срабатывают соответственно при выборе записи или при отмене выбора.
    * @examples
    * WebAccess.components.dialogs.ReferenceGridDialog.createAndShow({referenceName:"РАБ",mode:REFERENCE_MODAL_MODE.MULTI})
    * .selectionDone(function(result) { console.log('result', result); });
    * WebAccess.components.dialogs.ReferenceGridDialog.createAndShow({referenceName:"РАБ"}).selectionCancel(function() { console.log('cancel'); });
    */
    createAndShow: function (settings) {
      var def = $.Deferred();
      var dialog = new WebAccess.components.dialogs.ReferenceGridDialog(settings);
      dialog.bind("select", function (data) {
        def.resolve(data);
      });
      dialog.bind("close", function (data) {
        // Если Deferred зарезолвился, то reject уже не срабатывает.
        def.reject();
      });
      dialog.show();
      return {
        selectionDone: function (cb) {
          def.done(cb);
        },
        selectionCancel: function (cb) {
          def.fail(cb);
        }
      }
    },

    /**
    * Отправляет все выбранные значения справочника в родительское окно.
	*
    * @since 5.4.0.1013
    * @function WebAccess.components.dialogs.ReferenceGridDialog.sendMultiSelectedRecords
    * @param {string} referenceCode Код справочника
    * @param {WebAccess.components.wrappers.objectList.ListItem[]} opt_records Список записей для отправки.
    */
    sendMultiSelectedRecords: function (referenceCode, opt_records) {
      var records = opt_records || WA.CR.objectList.getSelectedItems();
      var convertedRecords = records.map(function (record) {
        return convertObjectListRecord(referenceCode, record);
      });
      sendRecordsToParent(convertedRecords);
    },

    /**
    * Отправляет выбранное значение справочника в родительское окно.
	*
    * @since 5.4.0.1021
    * @function WebAccess.components.dialogs.ReferenceGridDialog.sendRecordById
    * @param {string} referenceCode Код справочника
    * @param {string} recId ИД записи справочника
    */
    sendRecordById: function (referenceCode, recId, leaderRequisiteValues) {
      var record = WA.CR.objectList.getItems()[recId];
      record = convertObjectListRecord(referenceCode, record, leaderRequisiteValues);
      sendRecordsToParent([record]);
    }
  });

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  // Отправка объекта с выбранными значениями в родительское окно.
  function sendRecordsToParent(records) {
    var locationOrigin = !location.origin ? (location.protocol + '//' + location.host) : location.origin;
    window.parent.postMessage({
      destination: 'ReferenceGridDialog',
      selectedItems: records
    }, locationOrigin);
  }

  // Подготовка записи справочника для отправки в родительское окно (формирование объекта с необходимыми атрибутами).
  function convertObjectListRecord(referenceCode, record, leaderRequisiteValues) {
    return {
      id: record["id"],
      name: record["name"],
      code: record["code"],
      referenceCode: referenceCode,
      leaderRequisiteValues: leaderRequisiteValues
    };
  }

  global.ReferenceGridDialog = ReferenceGridDialog;
})(window.WebAccess.components.dialogs);
